export const TYPE_SERVICE = 'service';

export const FIELD_QUANTITY = 'quantity';
export const FIELD_NET_PRICE = 'netPriceFloat';
export const FIELD_AVERAGE = 'average';

export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';
